export default __webpack_public_path__ + "static/media/010-space capsule.4311a238.svg";